import { useEffect, useRef, useState } from "react";
import servConsultaPrevia from "../../../services/login/servConsultaPrevia";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";
import { logout } from "../../../state/slices/userSlice";
import styles from "./Cadastro.module.css";
import { format, parse } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import TabPanel from "../../../components/Tabpanel/Tabpanel";
import { defaultValues, schema, camposPorAba } from "./ValidacoesConsulta";
import { validarCnpj, validarCpf } from "../../../infra/utils/ValidacaoCpf";
import { formatarCnpj, formatarCpf } from "../../../infra/utils/FormataValores";
import { ErrorHandling } from "../../../components/Errors/Errors";
import { OpcoesUF } from "../../../components/Combobox/UF";
import { OpcoesTipoInscricao } from "../../../components/Combobox/TipoInscricao";
import servAnalises from "../../../services/login/servAnalises";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import servParam from "../../../services/login/servParam";
import { Box, Tabs, Tab, Snackbar, Alert, Modal, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { style as modalstyle } from "../../../components/Loading/Loading";
import { Interessado } from "./Abas/Interessado";
import { Localizacao } from "./Abas/Localizacao";
import { Tensao } from "./Abas/Tensao";
import { Documentos } from "./Abas/Documentos";
import { VisualizarAnalise } from "./Abas/ResultadoAnalise";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const Cadastro = ({
    setOpen,
    recordForEdit,
    setRecordForEdit,
    pesquisar,
    novoCadastro,
    setEhNovoCadastro,
    tabResultadoAnalise,
    analisesDaSolic,
    recordForView
}) => {

    const methods = useForm({ mode: "onBlur", defaultValues: defaultValues, resolver: yupResolver(schema) });
    const user = useSelector(state => state.user);
    const uc = useSelector(state => state.uc);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [tabIndex, setTabIndex] = useState(0);
    const [abasVisitadas, setAbasVisitadas] = useState(new Set([0]));
    const [podeSalvar, setPodeSalvar] = useState(true);

    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [typeAlert, setTypeAlert] = useState("error");
    const [isLoading, setIsLoading] = useState(false);

    const [analise, setAnalise] = useState(null);
    const [documentosObrigatorios, setDocumentosObrigatorios] = useState([]);
    const codigoTipoProjeto = methods.watch("CodigoTipoProjeto");

    const [erroAoRecuperarConsumidor, setErroAoRecuperarConsumidor] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);

    const [unidadeConsumidora, setUnidadeConsumidora] = useState(false);
    const [potenciaInstalada, setPotenciaInstalada] = useState(0);

    const [anexosAnalise, setAnexosAnalise] = useState(null);
    const salvandoRef = useRef(false);
    // tabResultadoAnalise fica true por toda a sessão do popup (não é "consumido" pelo
    // pai); sem esse ref, todo salvamento (que atualiza recordForEdit e reexecuta o
    // efeito abaixo) forçava de volta para a aba Resultado. Só aplica na primeira vez.
    const jaAplicouTabResultadoRef = useRef(false);

    const tabs =
        [
            { label: "Interessado", disabled: analisesDaSolic },
            { label: "Localização", disabled: analisesDaSolic },
            { label: "Tensao", disabled: analisesDaSolic },
            { label: "Documentos", disabled: analisesDaSolic },
            recordForEdit && !novoCadastro && recordForEdit.Situacao !== 0 && { label: "Resultado" }
        ].filter(Boolean);

    const lastTabIndex = tabs.length - 1;

    const commonTabStyles = {
        '&.Mui-disabled': {
            color: "#B8B8B8",
            borderBottom: "1px solid #B8B8B8",
        },
        color: "whitesmoke",
        borderBottom: "1px solid white",
    };

    const tabResultadoStyle = {
        '&.Mui-disabled': {
            color: "#B8B8B8",
            borderBottom: "1px solid white",
        },
        color: "whitesmoke",
        width: "60px",
        borderBottom: "1px solid white",
    };

    useEffect(() => {
        const situacoesBloqueadas = [1, 2, 3, 4, 6];

        const recuperarParticipantes = async () => {

            try {
                let id = analisesDaSolic ? recordForEdit[0].CodigoConsultaPrevia : recordForEdit.Id || recordForEdit.id;
                var data = await servConsultaPrevia.RecuperarParaEditar(id);
                var docsObrigatorios = await servParam.RecuperarDocumentosObrigatorios(14);
                var docsVinculados = await servConsultaPrevia.listarDocumentosPorConsultaPrevia(id);

                data = data.Content;
                docsObrigatorios = docsObrigatorios.Content;
                docsVinculados = docsVinculados?.Content ?? docsVinculados ?? [];

                if (!data.CodigoUc) {
                    setUnidadeConsumidora(true);
                    methods.setValue("NovaUC", true);
                    methods.clearErrors("CodigoUc");
                } else {
                    setUnidadeConsumidora(false);
                    methods.setValue("NovaUC", false);
                }

                if (tabResultadoAnalise && !jaAplicouTabResultadoRef.current) {
                    setTabIndex(4);
                    jaAplicouTabResultadoRef.current = true;
                }


                mapearRetorno(data);
                const docsAtualizados = mapearDocsComObrigatoriedade(docsObrigatorios, docsVinculados);
                setDocumentosObrigatorios(docsAtualizados);

                verificaCamposUc();
            } catch (err) {
                setIsLoading(false);
            }
        }

        const verificaCamposUc = async () => {
            if (!methods.getValues("CodigoUc") || !methods.getValues("Inscricao")) {
                return;
            }

            const situacoesBloqueadas = [1, 2, 3, 4, 6];

            if (situacoesBloqueadas.includes(recordForEdit?.Situacao)) return;

            let inscricao;

            if (methods.getValues("TipoInscricao")?.value == 1) {
                inscricao = formatarCpf(methods.getValues("Inscricao"));
                inscricao = inscricao.replaceAll("_", "");
            } else {
                inscricao = formatarCnpj(methods.getValues("Inscricao"));
            }

            if (inscricao < 11) {
                return
            }

            var dto = {
                CodigoUc: methods.getValues("CodigoUc"),
                Inscricao: inscricao
            };

            setErroAoRecuperarConsumidor(false);

            try {
                const data = await servConsultaPrevia.RecuperarDadosDoConsumidor(dto);
            } catch (error) {
                setErroAoRecuperarConsumidor(true);
            }
        }

        const recuperarUltimaAnalise = async () => {
            try {
                let id = analisesDaSolic ? recordForEdit[0].CodigoConsultaPrevia : recordForEdit.Id || recordForEdit.id;
                const data = await servAnalises.RecuperarUltimaAnaliseConsultaPrevia(id);

                let analise = data.Content;

                setAnalise(analise);

            } catch (err) {
                setIsLoading(false);
            }
        }

        if (novoCadastro === false) {
            if (recordForEdit === null) return;
    
            const carregarDados = async () => {
                setIsLoading(true);
                try {
                    await recuperarParticipantes();
    
                    if (recordForEdit.Situacao !== 0) {
                        await recuperarUltimaAnalise();
                    }
                } finally {
                    setIsLoading(false);
                }
    
                if (situacoesBloqueadas.includes(recordForEdit.Situacao)) setPodeSalvar(false);
            };
    
            carregarDados();
    
        } else {

            const recuperarDocumentosIniciais = async () => {
                try {
                    setIsLoading(true);


                    let response = await servParam.RecuperarDocumentosObrigatorios(14);
                    const docsObrigatorios = mapearDocsComObrigatoriedade(response.Content);
                    setDocumentosObrigatorios(docsObrigatorios);

                    methods.setValue('habilitaCodigoUc', true);

                    setIsLoading(false);
                } catch (err) {
                    setIsLoading(false);

                    setTypeAlert("error");

                    return ErrorHandling(
                        err?.request?.status,
                        err?.message,
                        setOpenError,
                        setErrorMessage,
                        dispatch,
                        logout,
                        navigate,
                        err?.response?.data?.Message
                    );
                }
            }

            recuperarDocumentosIniciais();
        }
    }, [recordForEdit]);

    // Reaplica a lógica de obrigatoriedade quando o tipo de projeto mudar
    useEffect(() => {
        if (documentosObrigatorios.length === 0) return;

        const docsAtualizados = mapearDocsComObrigatoriedade(documentosObrigatorios);
        setDocumentosObrigatorios(docsAtualizados);
    }, [codigoTipoProjeto]);

    const mapearDocsComObrigatoriedade = (docsObrigatorios, docsVinculados) => {
        const codigoTipo = codigoTipoProjeto?.value;
        return docsObrigatorios.map((doc) => {
            // Mantém o valor original de Obrigatorio (0, 1 ou 2)
            const docAtualizado = { ...doc };

            // Verifica se o tipo de projeto atual torna o documento aplicável
            let obrigatorioTipoProjeto = false;

            if (doc.Obrigatorio === 2 && doc.ConfigDocsTipoProjetos && Array.isArray(doc.ConfigDocsTipoProjetos)) {
                if (doc.ConfigDocsTipoProjetos.length === 0) {
                    // Array vazio = critério vale para todos
                    obrigatorioTipoProjeto = true;
                } else if (codigoTipo) {
                    obrigatorioTipoProjeto = doc.ConfigDocsTipoProjetos.some(
                        (item) => item.CodigoTipoProjeto === codigoTipo
                    );
                }
            }

            docAtualizado.ObrigatorioTipoProjeto = obrigatorioTipoProjeto;

            // Se tem docsVinculados, faz o merge (apenas na edição)
            if (docsVinculados) {
                const documentoVinculado = docsVinculados.find(
                    (docVinculado) =>
                        doc.Id == docVinculado.CodigoConfigDoc &&
                        doc.CodigoClassificacaoDoc == docVinculado.CodigoClassificacaoDoc
                );

                if (documentoVinculado) {
                    docAtualizado.CodigoDocumento = documentoVinculado.CodigoDocumento;
                    docAtualizado.NomeArquivo = documentoVinculado.NomeArquivo;
                    docAtualizado.Aprovado = documentoVinculado.Aprovado;
                }
            }

            return docAtualizado;
        });
    };

    const retornaDadosConsumidor = async (data) => {
        try {
            let inscricaoFormatada = data.TipoInscricao?.value === 1 ? formatarCpf(data.Inscricao) : formatarCnpj(data.Inscricao),
                dto = {
                    CodigoUc: data.CodigoUc,
                    Inscricao: inscricaoFormatada
                };

            const response = await servConsultaPrevia.RecuperarDadosDoConsumidor(dto);

            return Object.keys(response.Content).length > 0;
        } catch (error) {
            return false;
        }
    }

    const salvarDados = async (data) => {
        if (salvandoRef.current) return false;
        salvandoRef.current = true;

        try {
            if (data.TipoInscricao?.value === 1) {
                const cpf = formatarCpf(data.Inscricao);
                if (!validarCpf(cpf)) {
                    setTypeAlert("warning");
                    setErrorMessage("A inscrição informada é inválida");
                    setOpenError(true);
                    return false;
                }
            } else {
                const cnpj = formatarCnpj(data.Inscricao);
                if (!validarCnpj(cnpj)) {
                    setTypeAlert("warning");
                    setErrorMessage("A inscrição informada é inválida");
                    setOpenError(true);
                    return false;
                }
            }

            if (!unidadeConsumidora) {
                const contemDadosConsumidor = await retornaDadosConsumidor(data);
                if (!contemDadosConsumidor) {
                    setTypeAlert("warning");
                    setErrorMessage("Não foi encontrado consumidor com a combinação de UC e inscrição informadas.");
                    setOpenError(true);
                    return false;
                }
            }

            setIsLoading(true);

            const payload = {
                Id: data.Id,
                CodigoResponsavelTecnico: user.codigoUsuario,
                CodigoTipoProjeto: data.CodigoTipoProjeto?.value,
                CodigoUc: data.CodigoUc,
                TipoInscricao: data.TipoInscricao?.value,
                Inscricao: data.TipoInscricao?.value === 1 ? formatarCpf(data.Inscricao) : formatarCnpj(data.Inscricao),
                Nome: data.Nome,
                Email: data.Email,
                TelefoneCelular: data.TelefoneCelular,
                TelefoneCelularAlt: data.TelefoneCelularAlt,
                RamoAtividade: data.RamoAtividade,
                DemandaCalculada: data.DemandaCalculada,
                NomeLoteamento: data.NomeLoteamento,
                QuantidadeLotes: data.QuantidadeLotes,
                QuantidadeMedidoresUC: data.QuantidadeMedidoresUC,
                CargaInstaladaExistente: data.CargaInstaladaExistente,
                CargaAInstalar: data.CargaAInstalar,
                PrazoLigacaoDefinitiva: data.PrazoLigacaoDefinitiva,
                AumentoCarga: data.AumentoCarga,
                CargaPerturbadora: data.CargaPerturbadora,
                DescricaoCargaPerturbadora: data.DescricaoCargaPerturbadora,
                Endereco: data.Endereco,
                Cep: data.Cep.replace("-", "").replaceAll("_", ""),
                CodigoCidade: data.CodigoCidade,
                Cidade: data.Cidade,
                Rua: data.Rua,
                NumeroEnd: data.NumeroEnd,
                Complemento: data.Complemento,
                Uf: data.UF?.value,
                Longitude: data.Longitude,
                Latitude: data.Latitude
            };

            const response = !data.Id || data.Id === 0
                ? await servConsultaPrevia.Inserir(payload)
                : await servConsultaPrevia.Editar(payload);

            setTypeAlert("success");
            setErrorMessage(!data.Id || data.Id === 0 ? "Dados salvos com sucesso" : "Dados alterados com sucesso");
            setOpenError(true);

            setRecordForEdit(response.Content);
            setEhNovoCadastro(false);
            mapearRetorno(response.Content);
            pesquisar();

            salvandoRef.current = false;
            return true;
        } catch (err) {
            salvandoRef.current = false;
            setTypeAlert("error");
            ErrorHandling(
                err?.request?.status,
                err?.message,
                setOpenError,
                setErrorMessage,
                dispatch,
                logout,
                navigate,
                err?.response?.data?.Message
            );
            return false;
        } finally {
            setIsLoading(false);
            salvandoRef.current = false;
        }
    }

    const handleSubmitSalvar = async (event) => {
        event.preventDefault();

        const abaValida = await validarAbaAtual(tabIndex);
        if (!abaValida) {
            setTypeAlert("warning");
            setErrorMessage("Existem campos inválidos ou obrigatórios não preenchidos. Verifique os campos destacados.");
            setOpenError(true);
            return;
        }

        await salvarDados(methods.getValues());
    };

    const handleCadastroConsultaPrev = methods.handleSubmit(async (data, event) => {
        return await salvarDados(data);
    },

    (errors) => {
        const abaComErro = obterAbaDoErro(errors);
        if (abaComErro !== null) {
            setTabIndex(abaComErro);
        }
        setTypeAlert("warning");
        setErrorMessage("Existem campos inválidos ou obrigatórios não preenchidos. Verifique os campos destacados.");
        setOpenError(true);
    });

    const obterAbaDoErro = (errors) => {
        for (let abaIdx = 0; abaIdx <= 6; abaIdx++) {
            const campos = camposPorAba[abaIdx] || [];
            if (campos.some(campo => errors[campo])) {
                return abaIdx;
            }
        }
        return null;
    };

    const validarAbaAtual = async (abaIdx) => {
        const abaAtual = abaIdx !== undefined ? abaIdx : tabIndex;
        const camposDaAba = camposPorAba[abaAtual] || [];
        if (camposDaAba.length === 0) return true;
        const resultado = await methods.trigger(camposDaAba, {
            shouldFocus: true
        });
        return resultado;
    };

    const handleTabChange = async (event, newValue) => {
        if (isLoading) return;

        const isValid = await validarAbaAtual(tabIndex);

        if (!isValid) {
            setTypeAlert("warning");
            setErrorMessage("Preencha corretamente os campos obrigatórios antes de avançar.");
            setOpenError(true);
            return;
        }

        // Aba Resultado (4) não tem campos editáveis (fora de camposPorAba) — nada a
        // salvar ao sair dela, e tentar salvar mesmo assim só arrisca falhar (ex.:
        // revalidação de CPF/CNPJ ou consulta de UC) e travar a troca de aba à toa.
        if (podeSalvar && tabIndex !== 4) {
            const salvou = await salvarDados(methods.getValues());

            if (!salvou || Number(methods.getValues("Id")) === 0) {
                return;
            }
        }

        setAbasVisitadas(prev => new Set([...prev, tabIndex]));
        setTabIndex(newValue);
    };

    const proximaAba = async () => {
        if (isLoading) return;

        const isValid = await validarAbaAtual(tabIndex);

        if (!isValid) {
            setTypeAlert("warning");
            setErrorMessage("Preencha corretamente os campos obrigatórios antes de avançar.");
            setOpenError(true);
            return;
        }

        // Aba Resultado (4) não tem campos editáveis — nada a salvar ao sair dela (ver
        // mesma observação em handleTabChange).
        if (podeSalvar && tabIndex !== 4) {
            const salvou = await salvarDados(methods.getValues());

            if (!salvou || Number(methods.getValues("Id")) === 0) {
                return;
            }
        }

        setAbasVisitadas(prev => new Set([...prev, tabIndex]));

        const possuiResultado =
            recordForEdit &&
            !novoCadastro &&
            recordForEdit.Situacao !== 0;

        if (
            (!possuiResultado && tabIndex === 3) ||
            (possuiResultado && tabIndex === 4)
        ) {
            return setTabIndex(0);
        }

        setTabIndex((prev) => prev + 1);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenError(false);
        }

        setOpenError(false);
    }

    const fecharJanela = () => {
        setEhNovoCadastro(true);
        setOpen(false);
    }

    const validarDocumentosObrigatorios = () => {
        const docsObrigatoriosNaoAnexados = documentosObrigatorios.filter((doc) => {
            // Obrigatório fixo (valor 1)
            if (doc.Obrigatorio === 1) {
                return !doc.CodigoDocumento;
            }
    
            // Obrigatório por critério (valor 2) — valida se aplica ao tipo de projeto
            if (doc.Obrigatorio === 2 && doc.ObrigatorioTipoProjeto) {
                return !doc.CodigoDocumento;
            }
    
            return false;
        });
    
        return docsObrigatoriosNaoAnexados;
    };
    
    const handleClickOpenDialog = async (event, reason) => {
        try {
            const docsFaltando = validarDocumentosObrigatorios();
    
            if (docsFaltando.length > 0) {
                const nomes = docsFaltando.map((d) => `• ${d.Descricao}`).join("\n");
                setTypeAlert("warning");
                setErrorMessage(`Os seguintes documentos obrigatórios não foram anexados:\n${nomes}`);
                setOpenError(true);
                return;
            }
    
            await handleCadastroConsultaPrev();
    
            if (methods.getValues("TipoInscricao").value === 1) {
                let cpf = formatarCpf(methods.getValues("Inscricao"));
                if (!validarCpf(cpf)) {
                    setTypeAlert("warning");
                    setErrorMessage("A inscrição informada é inválida");
                    return setOpenError(true);
                }
            } else {
                let cnpj = formatarCnpj(methods.getValues("Inscricao"));
                if (!validarCnpj(cnpj)) {
                    setTypeAlert("warning");
                    setErrorMessage("A inscrição informada é inválida");
                    return setOpenError(true);
                }
            }
    
            if (reason === 'clickaway') {
                setOpenDialog(true);
            }
    
            setOpenDialog(true);
        } catch (err) {
            setOpenDialog(false);
            return setErrorMessage(err?.response?.data?.Message);
        }
    };
    
    const handleCloseDialog = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenDialog(false);
        }
    
        setOpenDialog(false);
    }
    
    const solicitarAnaliseInterno = async () => {
        try {
            setIsLoading(true);
    
            const id = methods.getValues("Id");
    
            await servConsultaPrevia.EnviarParaAnalise(id);
    
            setOpenDialog(false);
    
            setOpenError(true);
            setTypeAlert("success");
            setErrorMessage("Solicitação de análise enviada com sucesso.");
    
            setIsLoading(false);
    
            setTimeout(() => {
                fecharJanela();
                pesquisar();
            }, 800);
    
        } catch (err) {
            setIsLoading(false);
            setOpenDialog(false);
            setOpenError(true);
            setTypeAlert("error");
            setErrorMessage(err?.response?.data?.Message);
        }
    };

    const handleEnter = (event) => {
        if (event.keyCode === 13) {
            const form = event.target.form;
            const index = Array.prototype.indexOf.call(form, event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    }

    const mapearRetorno = (data) => {
        methods.setValue("Id", data.Id);
        methods.setValue("CodigoVisual", data.CodigoVisual);
        methods.setValue("Protocolo", data.Protocolo);

        if (data.TipoProjeto) {
            methods.setValue("CodigoTipoProjeto", {
                value: data.TipoProjeto.Id,
                label: data.TipoProjeto.Nome
            });
        }

        methods.setValue("TipoInscricao", {
            value: data.TipoInscricao,
            label: OpcoesTipoInscricao.find(op => op.value == data.TipoInscricao)?.label
        });

        methods.setValue("Inscricao", data.Inscricao);
        methods.setValue("Nome", data.Nome);
        methods.setValue("Email", data.Email);

        methods.setValue("TelefoneCelular", data.TelefoneCelular);
        methods.setValue("TelefoneCelularAlt", data.TelefoneCelularAlt);

        methods.setValue("RamoAtividade", data.RamoAtividade);
        methods.setValue("DemandaCalculada", data.DemandaCalculada);
        methods.setValue("NomeLoteamento", data.NomeLoteamento);
        methods.setValue("QuantidadeLotes", data.QuantidadeLotes);
        methods.setValue("QuantidadeMedidoresUC", data.QuantidadeMedidoresUC);
        methods.setValue("CargaInstaladaExistente", data.CargaInstaladaExistente);
        methods.setValue("CargaAInstalar", data.CargaAInstalar);
        methods.setValue("PrazoLigacaoDefinitiva", data.PrazoLigacaoDefinitiva);
        methods.setValue("AumentoCarga", data.AumentoCarga);
        methods.setValue("CargaPerturbadora", data.CargaPerturbadora);
        methods.setValue("DescricaoCargaPerturbadora", data.DescricaoCargaPerturbadora);

        methods.setValue("Endereco", data.Endereco);
        methods.setValue("Cep", data.Cep);
        methods.setValue("CodigoCidade", data.CodigoCidade);
        methods.setValue("Cidade", data.Cidade);
        methods.setValue("Rua", data.Rua);
        methods.setValue("NumeroEnd", data.NumeroEnd);
        methods.setValue("Complemento", data.Complemento);

        methods.setValue("Longitude", data.Longitude);
        methods.setValue("Latitude", data.Latitude);

        methods.setValue("DataCadastro", data.DataCadastro);
        methods.setValue("PrazoAnaliseConsulta", data.PrazoAnaliseConsulta);

        if (data.Uf) {
            methods.setValue("UF", {
                value: data.Uf,
                label: OpcoesUF.find(op => op.value == data.Uf)?.label
            });
        }

        if (!unidadeConsumidora) {
            methods.setValue("CodigoUc", data.CodigoUc);
        }

        methods.setValue("CodigoResponsavelTecnico", data.CodigoResponsavelTecnico);
    }

    const handleBtnSolicitarAnalise = () => {
        const botaoSolicitarAnalise = (
            <BlueHoverButton onClick={handleClickOpenDialog} disabled={!podeSalvar}>
                Solicitar análise
            </BlueHoverButton>
        );

        if (tabIndex === lastTabIndex) {
            return botaoSolicitarAnalise;
        }
    }

    const situacaoRegistro = Number(
        recordForEdit?.Situacao ?? recordForEdit?.row?.Situacao ?? 0
    );

    return (
        <div className={styles['modal-main']}>
            {methods.getValues("Id") !== 0 && (
                <div>
                    <header className={styles.header}>
                        {methods.getValues("DataCadastro") && (
                            <span className={styles.headerData}>
                                <div className={styles.dateBox}></div><b>Data de iní­cio: </b> {
                                    format(parse(methods.getValues("DataCadastro"), 'dd/MM/yyyy HH:mm:ss', new Date()), "dd/MM/yyyy", {
                                        locale: ptBR
                                    })
                                }
                            </span>
                        )}

                        {methods.getValues("PrazoAnaliseConsulta") && (
                            <span className={styles.headerData}>
                                <div className={`${styles.dateBox} ${styles['dateBox-green']}`}></div><b>Data prazo: </b>{
                                    methods.getValues("PrazoAnaliseConsulta") && (methods.getValues("PrazoAnaliseConsulta").includes("01/01/1900") || methods.getValues("PrazoAnaliseConsulta").includes("01/01/0001")) ?
                                        "Data ainda não definida" :
                                        format(parse(methods.getValues("PrazoAnaliseConsulta"), 'dd/MM/yyyy HH:mm:ss', new Date()), "dd/MM/yyyy", {
                                            locale: ptBR
                                        })
                                }
                            </span>
                        )}

                    </header>
                    <header className={styles.header}>
                        {methods.getValues("CodigoVisual") && (
                            <span className={styles.headerData}>
                                <div className={`${styles.dateBox} ${styles['dateBox-darkblue']}`}></div><b>Consulta prévia: </b> {methods.getValues("CodigoVisual")}
                            </span>
                        )}
                        {methods.getValues("Protocolo") && (
                            <span className={styles.headerData}>
                                <div className={`${styles.dateBox} ${styles['dateBox-gray']}`}></div><b>Protocolo: </b> {methods.getValues("Protocolo")}
                            </span>
                        )}
                    </header>
                </div>
            )}

            <FormProvider {...methods}>
                <form onSubmit={handleSubmitSalvar}>
                    <div className={styles.class100}>
                        <Box className={styles.boxTabs}>
                            <Tabs value={tabIndex} onChange={handleTabChange} aria-label="abas cadastro de consultas">
                                <Tab sx={commonTabStyles} label="Interessado" {...a11yProps(0)} disabled={analisesDaSolic} />
                                <Tab sx={commonTabStyles} label="Localização" {...a11yProps(1)} disabled={analisesDaSolic} />
                                <Tab sx={commonTabStyles} label="Dados Adicionais" {...a11yProps(2)} disabled={analisesDaSolic} />
                                {recordForEdit && recordForEdit.Situacao == 0 ?
                                    <Tab disabled={analisesDaSolic} sx={commonTabStyles} label="Documentos"  {...a11yProps(3)} />
                                    :
                                    <Tab sx={commonTabStyles} label="Documentos"  {...a11yProps(3)} disabled={analisesDaSolic} />
                                }
                                {recordForEdit && !novoCadastro && recordForEdit.Situacao !== 0 && <Tab sx={tabResultadoStyle} label="Resultado"  {...a11yProps(4)} />
                                }
                            </Tabs>
                        </Box>
                        <TabPanel value={tabIndex} index={0}>
                            <Interessado
                                situacaoSolic={recordForEdit && !novoCadastro ? recordForEdit.Situacao : 0}
                                desabilitarCamposSeHouverProtocoloGerado={methods.getValues("Protocolo")}
                                erroAoRecuperarConsumidor={erroAoRecuperarConsumidor}
                                setErroAoRecuperarConsumidor={setErroAoRecuperarConsumidor}
                                onKeyDown={handleEnter}
                                unidadeConsumidora={unidadeConsumidora}
                                setUnidadeConsumidora={setUnidadeConsumidora}
                                podeSalvar={podeSalvar}
                                uc={uc}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={1}>
                            <Localizacao
                                setIsLoading={setIsLoading}
                                situacaoSolic={recordForEdit && !novoCadastro ? recordForEdit.Situacao : 0}
                                codigoUc={methods.getValues("CodigoUc")}
                                onKeyDown={handleEnter}
                                unidadeConsumidora={unidadeConsumidora}
                                podeSalvar={podeSalvar}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={2}>
                            <Tensao
                                camposDesabilitados={podeSalvar}
                                onKeyDown={handleEnter}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={3}>
                            <Documentos
                                codigoConsulta={methods.getValues('Id')}
                                documentos={documentosObrigatorios}
                                setIsLoading={setIsLoading}
                                setOpenError={setOpenError}
                                setErrorMessage={setErrorMessage}
                                potenciaInstalada={potenciaInstalada}
                                situacaoSolic={situacaoRegistro}
                                parecerDocumentos={analise ? analise?.Documentacao?.Parecer : 0}
                                setTypeAlert={setTypeAlert}
                                unidadeConsumidora={unidadeConsumidora}
                                codigoTipoProjeto={codigoTipoProjeto}
                            />
                        </TabPanel>
                        <TabPanel value={tabIndex} index={4}>
                            <VisualizarAnalise
                                record={analise}
                                recordForView={recordForView}
                                anexos={anexosAnalise}
                            />
                        </TabPanel>
                    </div>
                    <div className={styles['consulta-botoes']} style={{ display: analisesDaSolic ? 'none' : 'flex' }}>
                        <BlueHoverButton type="submit" id="salvarConsultaPrev" name="salvarConsultaPrev" disabled={!podeSalvar || salvandoRef.current}>
                            Salvar
                        </BlueHoverButton>
                        {handleBtnSolicitarAnalise()}
                        <BlueHoverButton onClick={proximaAba}>
                            {tabIndex == 0 ? (
                                <div>Informar localização</div>
                            ) : tabIndex == 1 ? (
                                <div>Informar dados do projeto</div>
                            ) : tabIndex == 2 ? (
                                <div>Informar documentos</div>
                            ) : tabIndex === 3 && !novoCadastro && (recordForEdit && recordForEdit.Situacao !== 0) ? (
                                <div>Visualizar resultado análise</div>
                            ) : (
                                <div>Informar dados do interessado</div>
                            )}
                        </BlueHoverButton>
                        <BlueHoverButton onClick={fecharJanela} >
                            Cancelar
                        </BlueHoverButton>
                    </div>
                </form>
            </FormProvider>
            <Snackbar open={openError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={typeAlert} sx={{ width: "100%" }}>
                    {errorMessage}
                </Alert>
            </Snackbar>
            <Modal open={isLoading}>
                <Box style={modalstyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: "#232323", fontWeight: "bold" }}>
                    {"Solicitar análise"}
                </DialogTitle>
                <DialogContent sx={{ backgroundColor: "#232323" }}>
                    <DialogContentText id="alert-dialog-description" sx={{ color: "whitesmoke" }}>
                        Você deseja solicitar a análise da consulta prévia?
                        Após a solicitação, o registro só poderá ser alterado em uma eventual reprovação.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ backgroundColor: "#232323" }}>
                    <BlueHoverButton onClick={handleCloseDialog}>Cancelar</BlueHoverButton>
                    <BlueHoverButton autoFocus onClick={solicitarAnaliseInterno}>
                        Continuar
                    </BlueHoverButton>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export { Cadastro }